import React, { useEffect } from "react";

import { useMap } from "@app/component/map/FeaturedMap";
import GeoPath from "@app/types/GeoPath";
import { LASSO_POLYGON_OPTIONS } from "@app/util/lasso";

interface Props {
  path: GeoPath;
}

const Path: React.FC<Props> = ({ path }) => {
  const { map } = useMap();

  useEffect(() => {
    const lassoPolygon: google.maps.Polygon = new google.maps.Polygon({
      ...LASSO_POLYGON_OPTIONS,
      paths: path,
    });
    lassoPolygon.setMap(map);

    return () => {
      lassoPolygon?.setMap(null);
    };
  }, [map, path]);

  return null;
};

export default Path;
